import { COLORS } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { n_ai_analysis } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorAILevelBody = dynamic(() => import('../../new-portal/ai-tutor/AITutorAILevel'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const AITutorAILevelTobNav = () => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop } = useConversationAIFlow()
  const { t } = useTranslation()

  return (
    <div className="flex w-screen flex-row items-center justify-between py-[12px]">
      <QIcon_chevron_left width={'24px'} height={'24px'} color={COLORS.BLACK} onClick={() => pop()} />
      <div className="Body1-16Md">{t(n_ai_analysis.job_seg_level.title)}</div>
      <div></div>
    </div>
  )
}

const AITutorAILevelActivity: ActivityComponentType = () => {
  return (
    <WebviewStackContainer height="52px" title={<AITutorAILevelTobNav />} border={false}>
      <AITutorAILevelBody />
    </WebviewStackContainer>
  )
}

export default AITutorAILevelActivity
